import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import TWLogo from '../../assets/TW-Rental.svg';

const Home = () => {
  return (
    <div className="home-page">
      {/* Header Section */}
      <div className="home-header">
        <div className="logo">
          <img src={TWLogo} alt="TW Rental Logo" className="logo-svg" />
        </div>
        
        <div className="navigation">
          <Link to="/home" className="nav-button active">Home</Link>
          <Link to="/about" className="nav-button">About Us</Link>
          <Link to="/contact" className="nav-button">Contact Us</Link>
        </div>
      </div>
      
      {/* Main Content Section */}
      <div className="home-content">
        <div className="hero-section">
          <h1 className="hero-title">
            <div>Automation Management.</div>
            <div>We do it the right way.</div>
          </h1>
          <Link to="/contact" className="cta-button">GET IN TOUCH</Link>
        </div>
      </div>
      
      {/* Footer Section */}
      <div className="home-footer">
        <div className="copyright">© 2024. All Rights Reserved.</div>
        <div className="social-icons">
          <span className="social-icon">f</span>
          <span className="social-icon">📷</span>
          <span className="social-icon">in</span>
        </div>
      </div>
    </div>
  );
};

export default Home;
